export default {
  meg: {
      username: '姓名',
      email:'邮箱'
  }
}